import React from "react";
import ReactDom from "react-dom";
import { Navigation, Link, Router } from "react-router";
import AppHeader from "js/components/elements/sdk-header";
import { ZOOM_ICON } from "js/config.jsx";
import UserHandler from "js/utilities/user-handler";
import Validate from "js/utilities/validate";
import NoHal, {halCheck} from "js/utilities/no-hal";
import LoginButton from "html-components/LoginButton";
import Amplitude from "js/utilities/amplitude";
import TimerMixin from "react-timer-mixin";
import { getQueryString } from "js/utilities/get-query-string";

export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  getInitialState: function() {
    var email = "email=";

    return {
      email : getQueryString(email)
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if (UserHandler.loggedIn()) {
      return this.context.router.push("/docs");
    }
  },

  render: function() {

    if (UserHandler.loggedIn()){ return false; }

    return (
      <div className="bg">
        <div className="signin">
          <div className="box"style={{width: "650px"}}>
            <div className="header">
              <img src={ZOOM_ICON} className="img"/>
              <p className="title"></p>
            </div>
            <p className="login-text" style={{textAlign: "center", margin: "20px"}}>We've sent a login email to {this.state.email}</p>
            <p className="login-text" style={{fontSize:"1em", textAlign: "center", margin: "20px 0 0 0"}}>
              Didn't get any email?<br/>
              <Link to="/signin">Click here</Link> to send email again.
            </p>
            <br/>
          </div>
        </div>
      </div>

    );
  },


});



// WEBPACK FOOTER //
// ./src/js/components/screens/signin-email-sent.jsx